import React, { memo } from "react";
import useStyles from "../styles";
import { Grid } from "@material-ui/core";

const ItemInfo = ({ title, value }) => {
	const classes = useStyles();
	return (
		<Grid classes={{ root: classes.itemInfo }}>
			<Grid classes={{ root: classes.titleInfo }}>{title}</Grid>
			<Grid classes={{ root: classes.info }}>{value}</Grid>
		</Grid>
	);
};

export default memo(ItemInfo);
